const CustomToolbar = ({
  editorState,
  onToggleInlineStyle,
  onToggleBlockType,
  disabledButton,
}) => {


  // Define your custom buttons with SVG icons
  const buttons = [
    {
      style: "BOLD",
      icon: (
        <img
          src="/icons/bold.svg"
          alt="Bold"
          style={{ width: "20px", height: "20px" }}
        />
      ),
      label: "Bold",
    },
    {
      style: "ITALIC",
      icon: (
        <img
          src="/icons/itallic.svg"
          alt="itallic"
          style={{ width: "20px", height: "20px" }}
        />
      ),
      label: "Italic",
    },
    {
      style: "UNDERLINE",
      icon: (
        <img
          src="/icons/underline.svg"
          alt="underline"
          style={{ width: "20px", height: "20px" }}
        />
      ),
      label: "Underline",
    },
    {
      style: "STRIKETHROUGH",
      icon: (
        <img
          src="/icons/icon-area.svg"
          alt="Strikethrough"
          style={{ width: "20px", height: "20px" }}
        />
      ),
      label: "Strikethrough",
    },
    {
      style: "unordered-list-item",
      icon: (
        <img
          src="/icons/list-icon.svg"
          alt="ul"
          style={{ width: "20px", height: "20px" }}
        />
      ),
      label: "Bullet List",
    },
    {
      style: "ordered-list-item",
      icon: (
        <img
          src="/icons/number-list-icon.svg"
          alt="ol"
          style={{ width: "20px", height: "20px" }}
        />
      ),
      label: "Numbered List",
    },
  ];

  return (
    <div className="custom-toolbar">
      {buttons.map((button, index) => {
        const isActive =
          button.style === "unordered-list-item" ||
            button.style === "ordered-list-item"
            ? editorState
              .getCurrentContent()
              .getBlockForKey(editorState.getSelection().getStartKey())
              .getType() === button.style
            : editorState.getCurrentInlineStyle().has(button.style);

        return (
          <button
            key={index}
            className={`custom-toolbar-button ${isActive ? "active" : ""} ${disabledButton ? "disabled" : ""}`}
            disabled={disabledButton}
            onMouseDown={(e) => {
              e.preventDefault();
              if (disabledButton) return;
              if (
                ["BOLD", "ITALIC", "UNDERLINE", "STRIKETHROUGH"].includes(
                  button.style
                )
              ) {
                onToggleInlineStyle(button.style);
              } else {
                onToggleBlockType(button.style);
              }
            }}
            title={button.label}
          >
            {button.icon}
          </button>
        );
      })}
    </div>
  );
};

export default CustomToolbar;
